"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _dateFns = require("date-fns");
var _translation = require("../_utils/translation");
var _FilteredList = _interopRequireDefault(require("../FilteredList"));
var _excluded = ["anchorId", "translations"];
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: {
      '& p': {
        margin: 0
      }
    },
    itemLeft: {
      marginRight: '40px'
    }
  };
});
var dateFormat = 'MMM d, yyyy';
var displayEventDate = function displayEventDate(startDate, endDate) {
  if (startDate && endDate) {
    if ((0, _dateFns.isSameDay)(startDate, endDate)) return (0, _dateFns.format)(startDate, dateFormat);else return (0, _dateFns.format)(startDate, dateFormat) + ' - ' + (0, _dateFns.format)(endDate, dateFormat);
  } else {
    return '';
  }
};
var Item = function Item(props) {
  var online = props.online,
    city = props.city,
    country = props.country,
    title = props.title,
    url = props.url,
    venue = props.venue,
    booth = props.booth,
    translations = props.translations;
  var startDate = props['start-date'] && new Date(props['start-date']);
  var endDate = props['end-date'] && new Date(props['end-date']);
  var classes = useStyles();
  return __jsx(_core.Grid, {
    container: true,
    className: classes.wrapper
  }, __jsx(_core.Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, __jsx("p", null, displayEventDate(startDate, endDate)), __jsx("p", null, online && country ? __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: "".concat(translations.online, " (").concat(country, ") ")
    }
  }) : city && country && __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: "".concat(city, ", ").concat(country)
    }
  }))), __jsx(_core.Grid, {
    item: true,
    xs: 12,
    sm: 8
  }, __jsx(_core.Link, {
    href: url
  }, __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: title
    }
  })), __jsx("p", null, online ? "".concat(translations.online) : venue && booth ? __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: "".concat(venue, " , Booth: ").concat(booth)
    }
  }) : __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: venue
    }
  }))));
};
var ItemList = function ItemList(props) {
  var items = props.items,
    wrapperClass = props.wrapperClass,
    translations = props.translations;
  return __jsx("ul", {
    className: wrapperClass
  }, items && items.map(function (item, index) {
    return __jsx("li", {
      key: index
    }, __jsx(Item, (0, _extends2.default)({}, item, {
      translations: translations
    })));
  }));
};
var EventListing = function EventListing(props) {
  var anchorId = props.anchorId,
    _props$translations = props.translations,
    translations = _props$translations === void 0 ? _objectSpread({
      online: 'Virtual'
    }, _translation.commonListingTranslations) : _props$translations,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var translationsFilter = {
    appliedFilters: translations.appliedFilters,
    changeFilterCriteria: translations.changeFilterCriteria,
    done: translations.done,
    filters: translations.filters,
    invalidDate: translations.invalidDate,
    invalidEndDate: translations.invalidEndDate,
    invalidStartDate: translations.invalidStartDate,
    noSearchResults: translations.noSearchResults,
    uncheckAll: translations.uncheckAll
  };
  return __jsx(_FilteredList.default, (0, _extends2.default)({
    translations: translationsFilter,
    anchorId: anchorId
  }, otherProps, {
    dateRangeFacet: {
      start: {
        label: translations.dateRangeStart,
        itemKey: 'start-date',
        placeholder: translations.today,
        default: new Date()
      },
      end: {
        label: translations.dateRangeEnd,
        itemKey: 'end-date',
        placeholder: translations.selectDate
      }
    },
    checkboxFacets: [{
      label: translations.facetTopic,
      itemKey: 'categories',
      itemType: 'array',
      checkAllControl: true
    }, {
      label: translations.facetRegion,
      itemKey: 'region',
      itemType: 'array',
      checkAllControl: true
    }],
    dateFormat: dateFormat,
    datePickerProps: {
      disablePast: true
    },
    ItemListComponent: ItemList,
    itemListComponentProps: {
      translations: translations
    },
    sort: {
      key: 'start-date',
      direction: 'ascending',
      type: 'date'
    }
  }));
};
var EventListingEditConfig = {
  emptyLabel: 'Event / Trade Show Listing',
  isEmpty: function isEmpty(props) {
    if (props.listItems && props.listItems.length > 0) {
      return false;
    } else {
      return true;
    }
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/eventlisting')(EventListing, EventListingEditConfig);
exports.default = _default;